



















































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import SettingsMaterialItemForm from "./SettingsMaterialItemForm.vue";

import ModulesJson from "../../shared/ModulesJson";
import MaterialItemJson, {
  defaultMaterialItemJson,
  validateMaterialItemJson,
  validateMaterialItemJsonAdd,
} from "../../shared/MaterialItemJson";

import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import UserPermission, { defaultUserPermissionJson } from "../../shared/UserPermission";
import { UserPermissionType, UserPermissionTypeNames } from "../../shared/UserPermissionType";
import UserPermissionTypeInfoJson, { UserPermissionTypeInfos } from "../../shared/UserPermissionTypeInfoJson";

import { validateUserJson } from "../../shared/UserJson";
import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "SettingsMaterialItemDetails",
  components: {
    OverlayWindow,
    Loading,
    SettingsMaterialItemForm,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    allActiveModules: Array as PropType<ModulesJson[]>,
    mode: String,
    materialItemId: Number,
  },
  data() {
    return {
      editable: false as boolean,
      detailsTitle: "",
      detailsMode: "",
      loading: false as boolean,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.selectDetailsMode(this.mode);
    },

    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Material hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Material bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Material";
          this.editable = false;
          break;
      }
    },
  },
  watch: {},
  computed: {},
});
